import { render, staticRenderFns } from "./Accessability.vue?vue&type=template&id=ec3f76ec&scoped=true&"
import script from "./Accessability.vue?vue&type=script&lang=js&"
export * from "./Accessability.vue?vue&type=script&lang=js&"
import style0 from "./Accessability.vue?vue&type=style&index=0&id=ec3f76ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3f76ec",
  null
  
)

export default component.exports